import { ListItemIconProps, ListItemIcon as MuiListItemIcon } from '@mui/material';

type Props = Pick<ListItemIconProps, 'children' | 'className'>;

const ListItemIcon = ({ children, className }: Props) => {
  return <MuiListItemIcon className={className}>{children}</MuiListItemIcon>;
};

export default ListItemIcon;
